export const getters = {
    getAllWatchlist: state => [...state.stockWatchlist.watchlist, ...state.fundWatchlist.watchlist, ...state.goldWatchlist.watchlist],
    getAllStockWatchlist: state => state.stockWatchlist.watchlist,
    getStockWatchlist: state => state.stockWatchlist.watchlist.filter(item => !item.id.includes("-")),
    getIndiceWatchlist: state => state.stockWatchlist.watchlist.filter(item => item.id.includes("-")),
    getFundWatchlist: state => state.fundWatchlist.watchlist,
    getGoldWatchlist: state => state.goldWatchlist.watchlist,
    getLoadingWatchlist: state => state.loadingWatchlist,
    getCountWatchlistAsset: state => {
        let data = { count: 0, type: [] }
        if (state.fundWatchlist.watchlist.length) data.count += 1, data.type.push("fund")
        if (state.stockWatchlist.watchlist.length) data.count += 1, data.type.push("stock")
        if (state.goldWatchlist.watchlist.length) data.count += 1, data.type.push("gold")
        return data

    }

}
